import { saveAs } from "file-saver";

const mapCambiosToExcel = (data: any[]) =>
  data.map((c) => ({
    Codigo: c.codigo || "—",
    Titulo: c.titulo || "—",
    Solicitante: c.usuarioCreacion || "—",
    Estado: c.estado || "—",
    Prioridad: c.prioridad || "—",
    Riesgo: c.riesgo || "—",
    "Tipo de cambio": c.tipoCambio || "—",
    "Fecha programada": c.fechaProgramada || "—",
    "Fecha creación": c.fechaCreacion ? new Date(c.fechaCreacion).toLocaleString() : "—",
  }));

export const exportarExcelCambios = (data: any[], nameFile = "control-de-cambios") => {
  const filas = mapCambiosToExcel(data);
  const hoja = XLSX.utils.json_to_sheet(filas);
  hoja["!cols"] = Object.keys(filas[0] ?? {}).map(() => ({ wch: 22 }));
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, "Cambios");
  const buffer = XLSX.write(libro, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([buffer], { type: "application/octet-stream" }), nameFile + ".xlsx");
};